export default __webpack_public_path__ + "static/media/building.f0d78304.jpg";